import Button, {StyleType} from 'patient-ping-remedy/packages/button';
import {usePreReviewDraftStore} from '@/store/pre_review_draft_store';

/**
 * Header action (CARECO-6282) that renders the pre-review "Save draft" button in the task-detail
 * header beside Reject Referral. The active CareJourneyPreReview step registers its save handler and
 * state in {@link usePreReviewDraftStore}; this renders nothing when no pre-review step is mounted,
 * so it self-gates exactly like ReferralRejectHeaderAction. Back/Next stay in the review content.
 */
export default function PreReviewSaveDraftHeaderAction() {
  const save = usePreReviewDraftStore(state => state.save);
  const isSaving = usePreReviewDraftStore(state => state.isSaving);
  const disabled = usePreReviewDraftStore(state => state.disabled);

  if (!save) return null;

  return (
    <Button styleType={StyleType.SECONDARY} onClick={() => save()} disabled={disabled}>
      {isSaving ? 'Saving…' : 'Save draft'}
    </Button>
  );
}
